export default __webpack_public_path__ + "static/media/black_olive.fc3dfe95.png";